var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.522 16.071"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 11.359a2.35 2.35 0 0 0-1.581.621L4.768 8.632a2.23 2.23 0 0 0 0-1.129l5.688-3.316a2.415 2.415 0 1 0-.774-1.767 2.6 2.6 0 0 0 .073.565L4.066 6.3a2.42 2.42 0 1 0 0 3.534L9.81 13.19a2.3 2.3 0 0 0-.065.524 2.356 2.356 0 1 0 2.355-2.355"
  })));
};
export default SvgShare;